export default __webpack_public_path__ + "static/media/PPI-walkway-011.f5894fe2.jpg";